module.exports = __webpack_public_path__ + "img/copy-link-to-element.28f5ab81.gif";